import React from 'react';
import MarketingForm from '../components/MarketingForm';

const Marketing3 = () => {
  // Anie
  return <MarketingForm marketingNumber="Anie" phoneNumber="81517084557" />;
};

export default Marketing3;
